import {Chips} from 'primereact/chips'
import {forwardRef, useImperativeHandle, useState} from 'react'
const ChipsUtils = forwardRef(
    (
        {
            id,
            optionsList = [],
            placeholder,
            className,
            defaultValue = null,
            callBack = () => {},
            customDetail = false,
            inputId = '',
        },
        ref,
    ) => {
        useImperativeHandle(ref, () => ({
            value: value,
        }))

        const [value, setValue] = useState(defaultValue ? defaultValue : [])
        const handleOnChange = e => {
            setValue(e.value)
        }
        return (
            <div className="card p-fluid m-0 p-0">
                <Chips
                    value={value}
                    placeholder={placeholder}
                    onChange={handleOnChange}
                    className="w-full"
                />
            </div>
        )
    },
)

export default ChipsUtils
